import { Box } from '@mui/material'
import React from 'react'

const Loader = ({sx}) => {
  return (
    <div>
      <Box className="skeleton" height={"100dvh"} width={"100%"} sx={sx}></Box>
    </div>
  )
}

export default Loader
